import { SetNonNullable } from "type-fest";

/**
 * Get whether an org guide file version exists and does not represent a
 * deletion. (This is defined as being "extant".)
 */
export function isOrgGuideFileVersionExtant<
  T extends { contentsText: string | null },
>(version: T | null | undefined): version is SetNonNullable<T, "contentsText"> {
  return version != null && version.contentsText != null;
}
